
<h2 mat-dialog-title style="text-align: center;">
    Ajuste la cámara al código de barras
</h2>
<div mat-dialog-content class="center">
    <video #video autoplay style="width: 90%;"></video>
</div>
{{ code }}
<div mat-dialog-actions style="text-align: right;">
    <button  mat-raised-button color="primary" (click)="close()">Cancelar</button>
</div>